import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  SmartDialog,
  SmartForm,
} from 'components';
import { resetPassword } from 'redux/auth/actions';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';

class RecoverPasswordDialog extends Component {
  static propTypes = {
    email: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
    recoveryCode: PropTypes.string.isRequired,

    formatMessage: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  state = {
    open: true,
    showPassword: false,
  };

  onClose = () => {
    const { push } = this.props;
    this.setState({ open: false });
    push('/');
  }

  onOpen = () => this.setState({ open: true });

  onSave = (data) => {
    const { resetPassword, recoveryCode } = this.props;
    resetPassword({
      recoveryCode,
      ...data,
      onSuccess: this.onClose,
    });
  }

  toggleVisibility = () => this.setState(prevState => ({ showPassword: !prevState.showPassword }))

  render() {
    const { email, formatMessage } = this.props;
    const { open, showPassword } = this.state;
    const fields = [
      {
        fullWidth: true,
        kind: 'input',
        label: formatMessage('New Password'),
        name: 'password',
        required: true,
        type: showPassword ? 'text' : 'password',
        inputProps: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton style={{ outline: 'none' }} onClick={this.toggleVisibility}>
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        },
      },
    ];
    return (
      <SmartDialog
        noPadding
        onClose={this.onClose}
        open={open}
        title={`${formatMessage('Reset Password for')} - ${email}`}
      >
        <div>{formatMessage('Passwords are case sensitive')}</div>
        <SmartForm
          cancelButton={formatMessage('Cancel')}
          fields={fields}
          onCancel={this.onClose}
          onSave={this.onSave}
          saveButton={formatMessage('Submit')}
        />
      </SmartDialog>
    );
  }
}

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  resetPassword: payload => dispatch(resetPassword(payload)),
});

const wrappedRecoverPasswordDialog = connect(undefined, mapDispatchToProps)(RecoverPasswordDialog);

wrappedRecoverPasswordDialog.displayName = 'RecoverPasswordDialog';
export default wrappedRecoverPasswordDialog;
